//import blocks
import { gear_sale_enquiry_form_block } from "./gear_sale_enquiry_form_block";
import {gear_type_collection} from "./gear_type_collection";
import { headerBlock } from "./headerBlock";
import { footerBlock } from './footerBlock';
import { inner_block } from "./inner_block";
import { home_hero_block } from './home_hero_block';
import { brands_logos_block } from './brands_logos_block';
import { key_benefits_block } from './key_benefits_block';
import { certifications_block } from './certifications_block';
import { quote_block } from "./quote_block";
import { testimonial_block } from './testimonial_block';
import { branches_careers_resources_block } from './branches_careers_resources_block';
import { product_categories_block } from './product_categories_block';
import { text_hero_block } from './text_hero_block';
import { image_gallery_block } from './image_gallery_block';
import { details_block } from './details_block';
import { branch_image_block } from './branch_image_block';
import { company_updates_block } from './company_updates_block';
import { instagram_block } from './instagram_block';
import { resources_block } from './resources_block';
import { careers_block } from './careers_block';
import { branches_block } from './branches_block';
import { text_image_hero_block } from './text_image_hero_block';
import { company_history_block } from './company_history_block';
import { team_block } from './team_block';
import { faqs_block } from './faqs_block';
import { resources_archive_block } from './resources_archive_block';
import { location_details_block } from './location_details_block';
import { contact_us_block } from './contact_us_block';
import { industries_block } from './industries_block';
import { products_block } from './products_block';
import { article_text_block } from './article_text_block';
import { careers_hero_block } from './careers_hero_block';
import { featured_job_block } from './featured_job_block';
import { gear_block } from './gear_block';
import { product_details_block } from './product_details_block';
import { product_hero_block } from './product_hero_block';
import { map_block } from './map_block';
import { gear_summary_block } from './gear_summary_block';
import { product_archive_block } from './product_archive_block';

export function indexBlocks() {
    headerBlock()
    footerBlock()
    inner_block()
    home_hero_block()
    brands_logos_block()
    key_benefits_block()
    certifications_block()
    testimonial_block()
    branches_careers_resources_block()
    product_categories_block()
    text_hero_block()
    image_gallery_block()
    details_block()
    branch_image_block()
    company_updates_block()
    instagram_block()
    resources_block()
    careers_block()
    branches_block()
    text_image_hero_block()
    company_history_block()
    team_block()
    faqs_block()
    resources_archive_block()
    location_details_block()
    industries_block()
    contact_us_block()
    products_block()
    article_text_block()
    careers_hero_block()
    featured_job_block()
    gear_block()
    product_details_block()
    quote_block()
    gear_sale_enquiry_form_block()
    product_hero_block()
    map_block()
    gear_summary_block()
    product_archive_block()
    gear_type_collection()
}

